import { useContext } from 'react';
import { LineContext } from '../context/LineContext';

export const useLineContext = () => useContext(LineContext);
